const e=async(e,t,n)=>{await e.delete(`/apps/${n}/orgs/${t}`)};export{e as removeOrg};
//# sourceMappingURL=remove-org.mjs.map